import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { 
  Home, 
  Package, 
  History, 
  Wallet, 
  BarChart3, 
  Star,
  LogOut,
  Bike
} from 'lucide-react';

const BikerLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('tekstar_token');
    localStorage.removeItem('tekstar_user');
    navigate('/biker/login');
  };

  const menuItems = [
    { icon: Home, label: 'Dashboard', path: '/biker/dashboard' },
    { icon: Package, label: 'Deliveries', path: '/biker/deliveries' },
    { icon: Bike, label: 'Rides', path: '/biker/rides' },
    { icon: History, label: 'History', path: '/biker/history' },
    { icon: Wallet, label: 'Wallet', path: '/biker/wallet' },
    { icon: BarChart3, label: 'Analytics', path: '/biker/analytics' },
    { icon: Star, label: 'Reviews', path: '/biker/reviews' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navbar */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/biker/dashboard" className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-yellow-600 rounded-full flex items-center justify-center">
                <Bike className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Tekstar Biker</h1>
                <p className="text-xs text-gray-500">Delivery Partner Portal</p>
              </div>
            </Link>
            <Button
              onClick={handleLogout}
              variant="outline"
              className="flex items-center gap-2"
            >
              <LogOut className="h-4 w-4" />
              Logout
            </Button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid lg:grid-cols-[240px_1fr] gap-6">
          {/* Sidebar */}
          <aside className="lg:sticky lg:top-24 h-fit">
            <nav className="bg-white rounded-lg border border-gray-200 p-4 space-y-1">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                
                return (
                  <button
                    key={item.path}
                    onClick={() => navigate(item.path)}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-gradient-to-r from-orange-500 to-yellow-500 text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                    <span className="font-medium">{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </aside>

          {/* Main Content */}
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
};

export default BikerLayout;
